import React, { useState } from "react";
import "./modal.css";
import StarRating from "../Star/starRating";

const Modal = ({
  isOpen,
  onClose,
  onSubmit,
  testimonial,
  setTestimonial,
  onRatingSelect,
  rating,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (rating === 0) {
      setErrorMessage("Please give me 5 stars");
      return;
    }
    setLoading(true);
    setErrorMessage("");

    try {
      await onSubmit(testimonial);
      setTestimonial({ testimonial: "", name: "", rating: 0 });
      onRatingSelect(0);

      onClose();
    } catch (error) {
      // console.log("testimonial", error);
      setErrorMessage(
        "There was an error submitting your review. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-modal" onClick={onClose}>
          &times;
        </button>
        <h2>Leave a Review</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={testimonial.name}
            onChange={(e) =>
              setTestimonial({ ...testimonial, name: e.target.value })
            }
            placeholder="Your Name"
            required
          />
          <textarea
            value={testimonial.testimonial}
            cols="30"
            rows="10"
            onChange={(e) =>
              setTestimonial({ ...testimonial, testimonial: e.target.value })
            }
            placeholder="Your Review message"
            required
          />
          <StarRating rating={rating} onRatingSelect={onRatingSelect} />
          <button className="btn btnPrimary" type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>
    </div>
  );
};

export default Modal;
